import { createApp, createSSRApp } from 'vue';
import cmpBundleView from '../vue/BundleView.vue';

window.BundleView = (function(){
	const container = document.getElementById('component-bundle-view');
	const create = container?.querySelector('.bundle-detail-page') ? createSSRApp : createApp;
	const component = create(cmpBundleView, {
		bundleInfo: window.bundleInfo // todo: rename
	});
	delete window.bundleInfo; // todo: rename
	return component.mount('#component-bundle-view');
})();
